import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

import './styles.css';

const Breadcrumbs = (props) => {
    return (
        <div className="breadcrumb-interprise">
            <div className="container">
                <Breadcrumb>
                    <BreadcrumbItem><Link to='/'>DMV Imóveis</Link></BreadcrumbItem>                    
                    <BreadcrumbItem active>Lista de imóveis por categoria </BreadcrumbItem>
                </Breadcrumb>
            </div>
        </div>
    );
};

export default Breadcrumbs;